import { useEffect, useRef, useState } from 'react';
export const useSplitButtonDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const chevronRef = useRef(null);
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(e.target) &&
                !chevronRef.current?.contains?.(e.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);
    return { isOpen, setIsOpen, chevronRef, dropdownRef };
};
//# sourceMappingURL=useSplitButtonDropdown.js.map